import { ReactNode } from "react";
import { NavLink } from "react-router-dom";
import { InstallAppButton } from "./InstallAppButton";

export function AppShell({
  children,
  user,
  admin,
  megaReserve
}: {
  children: ReactNode;
  user: { email?: string; fullName?: string; role?: string };
  admin: boolean;
  megaReserve: boolean;
}) {
  return (
    <div className="shell">
      <aside className="sidebar">
        <div className="brand">
          <img src="/crm-autodialer/app/icon-192.png" alt="" />
          <div>
            <strong>CRM Autodialer</strong>
            <small>FalconJA · installable PWA</small>
          </div>
        </div>
        <nav className="nav-links">
          <NavLink to="/" end>
            Dashboard
          </NavLink>
          <NavLink to="/dialer">Dialer</NavLink>
          <NavLink to="/headset">Agent Headset</NavLink>
          <NavLink to="/contacts">Contacts</NavLink>
          <NavLink to="/campaigns">Campaigns</NavLink>
          <NavLink to="/calls">Call logs</NavLink>
          <NavLink to="/settings">Settings</NavLink>
          <NavLink to="/telephony">My Telephony</NavLink>
          {megaReserve ? <NavLink to="/mega-reserve">Mega Reserve</NavLink> : null}
          {admin ? <NavLink to="/admin">Admin</NavLink> : null}
          {admin ? <NavLink to="/admin/telephony">Telephony</NavLink> : null}
          <a href="/falconphone/app/" target="_blank" rel="noopener noreferrer" title="SIP softphone">
            SIP Softphone ↗
          </a>
        </nav>
        <div className="user-box">
          <strong>{user.fullName || user.email}</strong>
          <span>{user.email}</span>
          {admin ? (
            <div style={{ marginTop: 6 }}>
              <span className="badge active">Admin</span>
            </div>
          ) : null}
          <div style={{ marginTop: 10 }}>
            <InstallAppButton />
          </div>
          <div style={{ marginTop: 10 }}>
            <a href="/crm-autodialer/">Product page</a>
            {" · "}
            <a href="/account/">Account</a>
          </div>
        </div>
      </aside>
      <main className="main">{children}</main>
    </div>
  );
}
